import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Dashboard from "./components/Dashboard";

import "./styles/header.css";

function App() {
  return (
    <div>
      <header>
        <ul className="menu-list">
          <li className="selected">
            <a href="/">AWS CP Oncall</a>
          </li>
        </ul>
      </header>
      <Router>
        <Routes>
          <Route path="/" element={<Dashboard />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
